"use strict";
function RangeQuery(key, options) {
    return {
        range: (_a = {},
            _a[key] = options,
            _a)
    };
    var _a;
}
exports.RangeQuery = RangeQuery;
//# sourceMappingURL=RangeQuery.js.map


//////////////////
// WEBPACK FOOTER
// ./~/searchkit/lib/src/core/query/query_dsl/term_level/RangeQuery.js
// module id = 673
// module chunks = 0